var map = {
	"./menu-aprova-os.svg": 4131,
	"./menu-aprovar-os.svg": 3025,
	"./menu-atividades.svg": 3039,
	"./menu-catalogo.svg": 4809,
	"./menu-cliente.svg": 1321,
	"./menu-contrato.svg": 4085,
	"./menu-dashboard.svg": 6959,
	"./menu-etapas.svg": 9709,
	"./menu-fechamento-os.svg": 5174,
	"./menu-gantt.svg": 9825,
	"./menu-gemud.svg": 3177,
	"./menu-gerencia.svg": 5261,
	"./menu-gerenciamento.svg": 7940,
	"./menu-home.svg": 104,
	"./menu-inicio.svg": 9948,
	"./menu-orcamentos.svg": 8032,
	"./menu-organizacoes.svg": 1408,
	"./menu-os.svg": 2855,
	"./menu-painel.svg": 4034,
	"./menu-projetos.svg": 3857,
	"./menu-prospeccao.svg": 3726,
	"./menu-relatorio.svg": 4954
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8211;